<ng-container *ngIf="jobOpportunityInfo">
  <nz-divider></nz-divider>
  <h4 class="card-list__item-value">
    <mh-explanation-label [labelKey]="'conversation.job-opportunity.name.label'"></mh-explanation-label>
  </h4>
  <p class="card-list__item-label m-b-8">
    {{ jobOpportunityInfo.jobOpportunityName }}
  </p>
</ng-container>
